import React from 'react'
import { PrivacyNotice } from '@babylon/consumer-api/types'
import {
  useModalActions,
  Text as MedkitText,
  LinkButton,
  TextVariant,
} from '@babylon/medkit'

import {
  Box,
  Link,
  PopOver,
  Text,
  useDisclosure,
} from '@babylon/web-platform-ui'
import { GenericModal } from '@/components'

interface Props {
  notice: PrivacyNotice
  textVariant?: TextVariant
  useDnaV2Design?: Boolean
}

const NoticeLabel = ({ notice, textVariant, useDnaV2Design }: Props) => {
  const { openModal } = useModalActions()
  const { onOpen, onClose, isOpen } = useDisclosure()
  const { title, linkText, longText, noticeVersionId, onboardingText } = notice
  const linkCopy = linkText || title
  const needsModal = Boolean(longText)
  const onClick = () => openModal(<GenericModal content={longText!} />)

  const onboardingCopy = onboardingText || (!needsModal ? linkCopy : undefined)
  const checkboxLabelSpacing = onboardingCopy ? 3 : 0

  return (
    <>
      {!useDnaV2Design && (
        <MedkitText variant={textVariant || 'body'}>
          {onboardingCopy && (
            <span
              data-testid={`noticeCheckbox-onboardingText-${noticeVersionId}`}
            >{`${onboardingCopy} `}</span>
          )}

          {needsModal && linkCopy && (
            <LinkButton
              data-testid={`noticeCheckbox-linkButton-${noticeVersionId}`}
              onClick={onClick}
            >
              {linkCopy}
            </LinkButton>
          )}
        </MedkitText>
      )}

      {useDnaV2Design && (
        <Text>
          {onboardingCopy && (
            <span
              data-testid={`noticeCheckbox-onboardingText-${noticeVersionId}`}
            >{`${onboardingCopy} ${linkCopy}`}</span>
          )}

          {needsModal && linkCopy && (
            <>
              <PopOver isOpen={isOpen} onClose={onClose} marginTop={10}>
                {longText && (
                  <Box
                    sx={{
                      li: {
                        margin: '5px 40px',
                      },
                      padding: '1rem',
                    }}
                    data-testid="genericModalContent"
                    dangerouslySetInnerHTML={{ __html: longText }}
                  />
                )}
              </PopOver>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                data-testid={`noticeCheckbox-linkButton-${noticeVersionId}`}
                as="button"
                type="button"
                onClick={onOpen}
                marginTop={checkboxLabelSpacing}
              >
                {onboardingCopy ? 'View ' : ''}
                {linkCopy}
              </Link>
            </>
          )}
        </Text>
      )}
    </>
  )
}

export default NoticeLabel
